import React from 'react';

const ArrowBack = () => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11 6H1" stroke="#555B67" strokeWidth="1.5" />
    <path
      d="M6 10.875L1 6L6 1.125"
      stroke="#555B67"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowBack;
